export default __webpack_public_path__ + "static/media/padel-red.3b90653f.png";